import React from "react";
//#region types
import { TranslationKeys } from "translations";
//#endregion
//#region components
import { Grid } from "@mui/material";
//#endregion
import { LocalizationHelperInstance } from "utils/helpers";
import cssExports from "theme/styles/main.module.scss";

const DividendBodyText: React.FC = () => {
  return (
    <Grid container direction="column" flexWrap="nowrap" rowGap={2}>
      <Grid item>
        <ul className={cssExports.bodyListItems}>
          <li>{LocalizationHelperInstance.getFormattedMessage(TranslationKeys.AnnualAccount.TheAnnualReport)}</li>
          <li>
            {LocalizationHelperInstance.getFormattedMessage(
              TranslationKeys.AnnualAccount.TheAnnualGeneralMeetingMinutes
            )}
          </li>
          <li>{LocalizationHelperInstance.getFormattedMessage(TranslationKeys.AnnualAccount.TheIncomeTaxReturn)}</li>
        </ul>
      </Grid>

      <Grid item>
        {LocalizationHelperInstance.getFormattedMessage(TranslationKeys.AnnualAccount.ToApproveTodoMainActionBodyText)}
      </Grid>
    </Grid>
  );
};

export default DividendBodyText;
